import { IGetClienteCentroCustoDropDownUseCase } from "../../../presentation/useCases/read/get_cliente_centro_custo_dropdown_use_case";
import { ClienteCentroCustoDropDown } from "../../models/cliente_centro_custo_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetClienteCentroCustoDropDownUseCase
 */

export class GetClienteCentroCustoDropDownUseCase implements IGetClienteCentroCustoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getClienteCentroCustoDropDown(): Promise<ClienteCentroCustoDropDown[]> {
    return await this.repository.getClienteCentroCustoDropDown();
  }
}
